import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { server } from "../../server";
import { toast } from "react-toastify";

const ShopForgotPassword = () => {
  const [identifier, setIdentifier] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!identifier) {
      toast.error("Please provide your shop email or handle");
      return;
    }

    try {
      const response = await axios.post(`${server}/shop/forgot-password`, { email: identifier, handle: identifier });
      toast.success(response.data.message);
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="shop-forgot-password-component-container">
      <div className="shop-forgot-password-component-header">
        <h2>Forgot Shop Password</h2>
      </div>
      <div className="shop-forgot-password-component-form-container">
        <div className="shop-forgot-password-component-form">
          <form className="shop-forgot-password-component-form-elements" onSubmit={handleSubmit}>
            <div className="shop-forgot-password-component-form-group">
              <label htmlFor="identifier">Shop Email or Handle</label>
              <input
                type="text"
                name="identifier"
                required
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className="shop-forgot-password-component-input"
              />
            </div>
            <div>
              <button type="submit" className="shop-forgot-password-component-button">
                Send Reset Link
              </button>
            </div>
            <div className="shop-forgot-password-component-footer">
              <Link to="/shop-login">Back to Login</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ShopForgotPassword;